<div class="my-5">
    <sm-page-header
        [breadcrumb]="breadcrumb"
        title="settings.dacScenarios.edit.title">
    </sm-page-header>
    <div class="content">
        <sm-form-builder [formObject]="formObject" class="w-full px-4"></sm-form-builder>
        <div class="flex justify-end gap-2">
            <p-button [label]="'settings.dacScenarios.edit.add' | translate" (click)="update()" />
            <p-button [label]="'settings.dacScenarios.edit.cancel' | translate" severity="secondary" />
        </div>
        <div class="mt-10">
            <div class="flex justify-between items-center mb-4">
                <h3 class="text-xl font-semibold">{{ 'settings.dacScenarios.edit.steps.title' | translate }}</h3>
                <p-button 
                    [label]="'settings.dacScenarios.edit.modeEvaluationFinal.title' | translate" 
                    icon="pi pi-cog" 
                    severity="secondary" 
                    (click)="openGlobalEvaluationFinalModal()">
                </p-button>
            </div>
            <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data || []" [loading]="loading"></sm-data-table-builder>
        </div>

        <sm-drawer #drawer [drawer]="drawerObject"></sm-drawer>
        <sm-dialog #dialog [dialog]="dialogObject"></sm-dialog>
    </div>

</div>